import {defineMessages} from "@project/i18n";

export const representativeFieldLabelIds = {
  address: "fields.representative.address",
  companyId: "fields.representative.companyId",
  companyName: "fields.representative.companyName",
  contractedAt: "fields.representative.contractedAt",
  country: "fields.representative.country",
  durationMonths: "fields.representative.contractDuration",
  exclusive: "fields.representative.hasExclusivity",
  expiresOn: "fields.representative.renewalIn",
  logoUrl: "fields.representative.logoUrl",
  phoneNumber: "fields.representative.phoneNumber",
  phonePrefix: "fields.representative.phonePrefix",
  websiteUrl: "fields.representative.websiteUrl",
} as const;

export const representativeFieldMessages = defineMessages({
  address: {
    id: "fields.representative.address",
    defaultMessage: "Address",
    description: "Representative field label for postal address",
  },
  companyId: {
    id: "fields.representative.companyId",
    defaultMessage: "Company ID",
    description: "Representative field label for company registration identifier",
  },
  companyName: {
    id: "fields.representative.companyName",
    defaultMessage: "Company name",
    description: "Representative field label for company name",
  },
  contractedAt: {
    id: "fields.representative.contractedAt",
    defaultMessage: "Contracted at",
    description: "Representative field label for contract start date",
  },
  country: {
    id: "fields.representative.country",
    defaultMessage: "Country",
    description: "Representative field label for country",
  },
  durationMonths: {
    id: "fields.representative.contractDuration",
    defaultMessage: "Contract duration",
    description: "Representative field label for contract duration in months",
  },
  exclusive: {
    id: "fields.representative.hasExclusivity",
    defaultMessage: "Exclusivity",
    description: "Representative field label for exclusivity flag",
  },
  expiresOn: {
    id: "fields.representative.renewalIn",
    defaultMessage: "Expires on",
    description: "Representative field label for server-derived contract expiry date",
  },
  logoUrl: {
    id: "fields.representative.logoUrl",
    defaultMessage: "Logo URL",
    description: "Representative field label for company logo URL",
  },
  phoneNumber: {
    id: "fields.representative.phoneNumber",
    defaultMessage: "Phone number",
    description: "Representative field label for phone number",
  },
  phonePrefix: {
    id: "fields.representative.phonePrefix",
    defaultMessage: "Phone prefix",
    description: "Representative field label for phone prefix",
  },
  websiteUrl: {
    id: "fields.representative.websiteUrl",
    defaultMessage: "Website URL",
    description: "Representative field label for website URL",
  },
});
